"use client";

import React from "react";
import type { AgentT } from "@/app/profile/agents/page";
import { useApp } from "@/forApp/states/appState/appState";
import Button from "@/shared/Buttons/Button";
import Modal from "@/shared/Modal/Modal";
import styles from "./styles.module.css";

interface DeleteAgentModalProps {
	agent: AgentT;
	onConfirm: () => Promise<void>;
}

const DeleteAgentModal: React.FC<DeleteAgentModalProps> = ({
	agent,
	onConfirm,
}) => {
	const { delModal } = useApp();
	const [isLoading, setIsLoading] = React.useState(false);

	const handleConfirm = async () => {
		setIsLoading(true);
		try {
			await onConfirm();
			delModal();
		} catch (error) {
			console.error("Error deleting agent:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleCancel = () => {
		delModal();
	};

	return (
		<Modal title="Удаление агента">
			<div className={styles.modalContent}>
				<p className={styles.message}>
					Вы уверены что хотите удалить агента{" "}
					<span className={styles.agentName}>{agent.name}</span>?
				</p>

				<div className={styles.buttonsContainer}>
					<Button
						text={isLoading ? "Удаление..." : "Да"}
						color="red"
						onClick={handleConfirm}
						isLoading={isLoading}
					/>
					<Button
						text="Нет"
						color="gray"
						onClick={handleCancel}
						disabled={isLoading}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default DeleteAgentModal;
